(function () {
    "use strict";

    const chosenCodes = [
        "Languages",
        "Nationalities",
        "AddressTypesIVM",
        "Countries",
        "IVMLevels",
        "VMTypes",
        "AttachmentTypes",
        "ScanningStatus",
        "Postals",
        "CivilStates",
        "PersonType",
        "StatusRequestsFVM",
        "LegalForms",
        "StatusDossiers",
        "FVMLevels",
        "StatusRequestsIVMFromFVM",
        "StatusRequestsHomologation",
        "StatusInvoices",
        "PersonalActions",
        "FinalResults",
        "AddressTypesFVM",
        "FVMVILevels",
        "FVMCISLevels",
        "InvoiceTypes",
        "JobFunctions",
        "RequestTypes",
        "ScreeningResults",
        "ScreeningResultsCOL",
        "ScreeningTypes",
        "StatusRequestsIVM",
        "StatusScreenings",
        "StatusUsers",
        "StatusVM",
        "OrganisationTypes",
        "PersonalActionsIVM",
        "Partners",
        "AgendaItemResult",
        "AgendaMeetingType",
        "StatusAgenda",
        "SimpleStates",
        "PartnersForFVMScreening",
        "LogbookEntryTypes",
        "InstallationClasses",
        "InstallationPurposes",
        "PhysicalInstallationStatusCodes",
        "JustificationPhases",
        "AccountEventTypes",
        "JustificationActions",
        "SecurityIncidentStatus",
        "CisApprovalTypes",
        "CisStatusCodes",
        "OrganisationJustificationStatusCodes",
        "PhysicalInstallationZoneTypes",
        "CisTypes",
        "SecuredZoneUseCases",
        "RelationTypes",
        "ClassificationLevels",
        "LivingArrangements",
        "CisAdministratorTypes",
    ];

    angular.module("app").constant("chosenCodes", chosenCodes);
})();
